import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Alert, Spin } from "antd";
import {
	useParams,
	useRouteMatch,
	Route,
	Switch,
	Link,
} from "react-router-dom";

import { getOneVoting } from "../../store/thunks/get-one-voting";
import EditingVoting from "./components/editing-voting";
import MainInfo from "./components/main-info";
import Results from "./components/results/results";

import "./voting-item.scss";

const VotingItem = ({ height }) => {
	const { id } = useParams();
	const isEditing = !!useRouteMatch("/Voting/:id/editing");
	const dispatch = useDispatch();
	const voting = useSelector((state) => state.votingStore.voting);
	const itemLoading = useSelector((state) => state.votingStore.itemLoading);

	const styleContainer = {
		height: height,
		overflowY: "auto",
		overflowX: "hidden",
	};
	useEffect(() => {
		(async () => {
			await dispatch(getOneVoting(id));
		})();
	}, [id, isEditing]);

	if (itemLoading) {
		return (
			<Spin
				style={{ minHeight: 500 }}
				size="large"
				spinning={itemLoading}
				tip="Загрузка..."
				delay={100}
				key={id}
			>
				<div />
			</Spin>
		);
	}

	if (!itemLoading && !voting) {
		return (
			<div style={{ width: "100%", display: "flex", justifyContent: "center" }}>
				<Alert
					style={{ marginTop: "20px" }}
					message="Опрос не найден"
					description={
						<span style={{ textAlign: "left" }}>
							Почему это могло произойти:
							<ul>
								<li>опрос удалён</li>
								<li>в ссылке некорректные данные</li>
								<li>такого опроса не существует</li>
							</ul>
							<Link to="/Voting">Перейдите к списку опросов</Link>
						</span>
					}
					type="error"
					showIcon
				/>
			</div>
		);
	}
	return (
		<div className="voting-item" style={styleContainer}>
			{voting && (
				<Switch>
					<Route exact path={"/Voting/:id"}>
						<MainInfo />
						<Results voting={voting} />
					</Route>
					<Route path={"/Voting/:id/editing"}>
						<EditingVoting height={height} voting={voting} />
					</Route>
				</Switch>
			)}
		</div>
	);
};

export default VotingItem;
